import { render, staticRenderFns } from "./ClientTitleModal.vue?vue&type=template&id=0057f09c"
import script from "./ClientTitleModal.vue?vue&type=script&lang=js"
export * from "./ClientTitleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports